import * as tslib_1 from "tslib";
import { OWA_AUTO_LINKS_CLASSNAME, X_OWA_AUTO_LINKS_CLASSNAME } from './constants';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { format } from 'owa-strings';
import { trace } from 'owa-trace';
import { lazyWasAnyLinkRemoved, lazyRefreshSharingTips, } from 'owa-attachment-well-data';
var wasAnyLinkRemoved;
var refreshSharingTips;
export default function getAllSharePointLinks(editor, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var existingLinkIdMap;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
                        return [2 /*return*/];
                    }
                    existingLinkIdMap = {};
                    getLinksBasedOnClassName(OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
                    getLinksBasedOnClassName(X_OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
                    if (!!wasAnyLinkRemoved) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyWasAnyLinkRemoved.import()];
                case 1:
                    wasAnyLinkRemoved = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!wasAnyLinkRemoved(viewState, existingLinkIdMap)) return [3 /*break*/, 5];
                    logUsage(datapoints.AttachmentComposeSPLinkRemove.datapoint.name);
                    if (!!refreshSharingTips) return [3 /*break*/, 4];
                    return [4 /*yield*/, lazyRefreshSharingTips.import()];
                case 3:
                    refreshSharingTips = _a.sent();
                    _a.label = 4;
                case 4:
                    refreshSharingTips(viewState, parentItemIdWrapper.itemId, infoBarAddHandler, infoBarRemoveHandler);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getLinksBasedOnClassName(className, editor, existingLinkIdMap) {
    var allSPLinks = editor.queryContent('.' + className);
    for (var i = 0; i < allSPLinks.length; i++) {
        var link = allSPLinks[i];
        existingLinkIdMap[link.id] = true;
    }
    trace.info(format('getLinksBasedOnClassName: Found {0} SP links.', allSPLinks.length));
}
//# sourceMappingURL=getAllSharePointLinks.js.map